import { ApiService } from '../ApiService';
import type { 
  ReconcilePayload, 
  ReconcileResult, 
  UnreconciledResponse, 
  UnreconciledParams,
  ReconciliationGroups,
  UnreconcileResult 
} from '../../../types/reconciliation';

/**
 * Endpoints de lettrage comptable — préfixe /ledger/reconciliation
 * Source: API DOCUMENTATION/reconciliation.md
 */
export const reconciliationApi = {
  /**
   * POST /ledger/reconciliation — Lettrer des lignes
   * Assigne un matchingNumber commun aux lignes sélectionnées
   */
  reconcile: (payload: ReconcilePayload) =>
    ApiService.post<{ success: boolean; data: ReconcileResult }>(
      '/ledger/reconciliation', 
      payload
    ),

  /**
   * DELETE /ledger/reconciliation/:matchingNumber — Dé-lettrer
   * Supprime le matchingNumber de toutes les lignes du groupe
   */
  unreconcile: (matchingNumber: string) =>
    ApiService.delete<{ success: boolean; data: UnreconcileResult }>(
      `/ledger/reconciliation/${encodeURIComponent(matchingNumber)}`
    ),

  /**
   * GET /ledger/reconciliation/accounts/:accountId/unreconciled — Lignes non lettrées
   * Retourne les lignes POSTED sans matchingNumber
   */
  getUnreconciled: (accountId: string, params?: UnreconciledParams) =>
    ApiService.get<{ success: boolean; data: UnreconciledResponse }>(
      `/ledger/reconciliation/accounts/${accountId}/unreconciled`,
      params
    ),

  /**
   * GET /ledger/reconciliation/accounts/:accountId/groups — Groupes lettrés
   * Retourne les lignes lettrées groupées par matchingNumber
   */
  getGroups: (accountId: string) =>
    ApiService.get<{ success: boolean; data: ReconciliationGroups }>(
      `/ledger/reconciliation/accounts/${accountId}/groups`
    ),
};
